import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import FullTestResultSummary from '../components/full_mock_test/attempt/FullTestResultSummary';
import { logout, isUserNotFoundError } from '../utils/auth';

const FullTestResultPage = () => {
  const { attemptId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [result, setResult] = useState(location.state?.result || null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(!result); // Only load if no result was passed in state

  useEffect(() => {
    // If result is already available from navigation state, no need to fetch.
    if (result) return;

    const fetchResult = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (!token) throw new Error('Authentication token not found.');
        
        const response = await fetch(`${process.env.REACT_APP_API_URL}/exam-attempts/${attemptId}/result`, {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          if (isUserNotFoundError(response, errorData)) {
            logout(navigate);
            return;
          }
          throw new Error('Failed to fetch exam results.');
        }

        const data = await response.json();
        setResult(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (attemptId) {
      fetchResult();
    }
  }, [attemptId, result]);

  if (loading) {
    return (
        <div style={{
          minHeight: '100vh', background: '#FFF8E7',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: '"Nunito", "Baloo 2", sans-serif',
        }}>
          <div className="animate-spin" style={{
            width: 72, height: 72, borderRadius: '50%',
            borderBottom: '4px solid #E76F51',
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderTop: '4px solid transparent',
          }} />
        </div>
    );
  }

  if (error) {
    return (
      <div style={{
        minHeight: '100vh', background: '#FFF8E7',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: '"Nunito", "Baloo 2", sans-serif',
        padding: 24,
      }}>
        <div style={{
          background: '#fff', color: '#2D2D2D',
          border: '1px solid #E8E0CC', boxShadow: '0 2px 6px rgba(139,111,71,0.08)',
          borderRadius: 18, padding: '18px 24px',
          fontSize: 15, fontWeight: 800,
        }}>
          ⚠ {error}
        </div>
      </div>
    );
  }

  return <FullTestResultSummary result={result} attemptId={attemptId} />;
};

export default FullTestResultPage;
